/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessengerSettings {
    angular.module('meevo.plugins.meevoMessengerSettings', []);
}
